import React, { useLayoutEffect } from 'react';
import { useDispatchLegends } from "components/common/legendContext";

export default function TextLegen({ code, description, onlyLegend, icon, legendFixed, expandedId }) {
    const isCode = code || false // default value to false
    const isOnlyLegend = onlyLegend || false // default value to false
    const dispatch = useDispatchLegends();

    useLayoutEffect(() => {
        if (isCode && dispatch) {
            let payload
            if (icon) {
                payload = {
                    id: code,
                    name: description,
                    icon: icon,
                    hideHeader: false
                }
            } else {
                payload = { id: code, name: description, legendFixed: legendFixed, expandedId: expandedId }
            }
            dispatch({
                type: 'addlegend',
                payload: payload
            })
        }

    })

    return (
        <>
            {isCode && !isOnlyLegend
                ? <><abbr aria-hidden="true" title={description}>{icon ? icon : code}</abbr><span className="sr-only">{description}</span></>
                : ''
            }
        </>
    );

}